class APIMockSearch {
  constructor() {
    this.data = [
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "mock" },
          text: "Let's resume our session.",
          id: "welcome",
        },
      },
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "mock" },
          status: "typing",
          text: "",
          thinking: true,
          id: "/sample-search/eng/9",
        },
      },
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          id: "/sample-search/eng/9",
          values: {
            button: "Search",
            continue: false,
            format: "search",
            mode: "popup",
            id: "/sample-search/eng/9/0",
            instruction: "Pick the closest matching:",
            placeholder: "Search for insurance",
            sender: { id: "bot" },
            showDefaultInput: true,
            showDefaultUI: true,
            subtext: "Tap here to Type and we will search for you.",
            text: "Let's see if we can find your primary insurance carrier.",
          },
          continue: false,
          showDefaultUI: true,
          showDefaultInput: true,
          format: "module_insurance_policy",
          progress: 27.2,
        },
      },
    ];

    this.callback = null;
    this.update_callback = null;
  }

  initiate() {
    const _self = this;

    let timerId = setInterval(function() {
      const lastReq = _self.data.shift();
      if (lastReq) {
        _self.callback && _self.callback(lastReq.data);
      } else {
        console.log("no data");
      }
      //}, Math.round(Math.random() * 1000));
    }, 2000);
  }

  on(message_type, callback) {
    if (message_type === "MESSAGE") {
      this.callback = callback;
    } else if (message_type === "UPDATES") {
      this.update_callback = callback;
    }
  }

  emit(message_type, data, cb) {
    console.log(message_type, data);

    if (data.action === "startEdit") {
      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          id: "/sample-search/eng/9",
          values: {},
          continue: false,
          showDefaultUI: true,
          showDefaultInput: true,
          text: "Let's see if we can find your primary insurance carrier.",
          subtext: "Tap here to Type and we will search for you.",
          format: "search",
          progress: 27.2,
        },
      });

      return;
    }

    if (data.answer.reference && data.answer.typing.length > 0) {
      var country_list = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua &amp; Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia &amp; Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Cote D Ivoire",
        "Croatia",
        "Cruise Ship",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Polynesia",
        "French West Indies",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kuwait",
        "Kyrgyz Republic",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Pakistan",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Pierre &amp; Miquelon",
        "Samoa",
        "San Marino",
        "Satellite",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "St Kitts &amp; Nevis",
        "St Lucia",
        "St Vincent",
        "St. Lucia",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor L'Este",
        "Togo",
        "Tonga",
        "Trinidad &amp; Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks &amp; Caicos",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Virgin Islands (US)",
        "Yemen",
        "Zambia",
        "Zimbabwe",
      ];

      var insurance_list = [
        {
          ranking: "1",
          name: "*SELF PAY*",
          percentage: "72.44258872651356993736951983298538622129",
          insurancepackageid: "0",
        },
        {
          ranking: "2",
          name: "HUMANA (PPO)",
          percentage: "14.09185803757828810020876826722338204593",
          phone: "(800) 558-4444",
          insuranceproducttypename: "PPO",
          state: "KY",
          zip: "40512-4601",
          city: "LEXINGTON",
          insurancepackageid: "31724",
          address: "PO BOX 14601",
        },
        {
          ranking: "3",
          name: "PAYMENT PLAN",
          percentage: "3.02713987473903966597077244258872651357",
          insurancepackageid: "-500",
        },
        {
          ranking: "4",
          name: "BCBS-MA: BCBS (PPO)",
          percentage: ".6263048016701461377870563674321503131524",
          phone: "(800) 882-2060",
          insuranceproducttypename: "PPO",
          state: "MA",
          zip: "02298-6020",
          city: "BOSTON",
          insurancepackageid: "8477",
          address: "PO BOX 986020",
        },
        {
          ranking: "5",
          name: "BCBS-TN: (PPO)",
          percentage: ".5219206680584551148225469728601252609603",
          phone: "(800) 705-0391",
          insuranceproducttypename: "PPO",
          state: "TN",
          zip: "37402-0002",
          city: "CHATTANOOGA",
          insurancepackageid: "9037",
          address: "1 CAMERON HILL CIR STE 2",
        },
        {
          ranking: "5",
          name: "IBEW LOCAL 490 HEALTH & WELFARE",
          percentage: ".5219206680584551148225469728601252609603",
          phone: "(800) 248-0029",
          insuranceproducttypename: "OTHER",
          state: "NH",
          zip: "03821-0271",
          city: "DOVER",
          insurancepackageid: "10389",
          address: "PO BOX 271",
        },
        {
          ranking: "5",
          name: "MEDICARE-TN (MEDICARE)",
          percentage: ".5219206680584551148225469728601252609603",
          phone: "(877) 567-7271",
          insuranceproducttypename: "Medicare B-Traditional",
          state: "SC",
          zip: "29202-3306",
          city: "COLUMBIA",
          insurancepackageid: "18669",
          address: "PO BOX 100306",
        },
        {
          ranking: "5",
          name: "BCBS-MA: SAVER DEDUCTIBLE (PPO)",
          percentage: ".5219206680584551148225469728601252609603",
          phone: "(800) 443-6657",
          insuranceproducttypename: "PPO",
          state: "MA",
          zip: "02298-6020",
          city: "BOSTON",
          insurancepackageid: "90283",
          address: "PO BOX 986020",
        },
      ];
      const response = insurance_list
        .filter(c => c.name.toLowerCase().indexOf(data.answer.typing.toLowerCase()) > -1)
        .map(c => ({ name: c.name, value: c }));

      if (data.answer.reference && data.answer.reference.id == "/sample-search/eng/10") {
        let insurancetype_list = [
          "HMO",
          "PPO",
          "Medicare B B-Traditional",
          "Other",
          "Medicare Replacement",
          "EPO",
          "POS",
          "HDHPS",
          "HSA",
        ];

        let filetered_list = insurancetype_list
          .filter(c => c.toLowerCase().indexOf(data.answer.typing.toLowerCase()) > -1)
          .map(c => ({ name: c, value: c }));

        this.data.push({
          message_type: "MESSAGE",
          data: {
            continue: false,
            format: "search",
            id: "/sample-search/eng/10",
            showDefaultInput: true,
            values: {
              typing: data.answer.typing,
              suggestions: filetered_list,
            },
            _id: "/sample-search/eng/10",
          },
        });
      } else {
        this.data.push({
          message_type: "MESSAGE",
          data: {
            _id: "/sample-search/eng/9",
            format: "module_insurance_policy",
            id: "/sample-search/eng/9",
            sender: { id: "bot" },
            values: {
              id: "/sample-search/eng/9/0",
              typing: data.answer.typing,
              isPickOnly: true,
              suggestions: response,
            },
            continue: false,
            showDefaultUI: true,
            showDefaultInput: true,
          },
        });
      }
    } else if (typeof data.answer === "string") {
      if (data.answer == "other") {
        this.data.push({
          message_type: "MESSAGE",
          data: {
            sender: { id: "bot" },
            status: "typing",
            text: "",
            thinking: true,
            id: "/sample-search/eng/11",
          },
        });

        this.data.push({
          message_type: "MESSAGE",
          data: {
            sender: { id: "bot" },
            format: "search",
            values: {
              id: "/sample-search/eng/11/answer",
              text: data.answer,
            },
            id: "/sample-search/eng/10",
            showDefaultInput: false,
            showDefaultUI: true,
            progress: 27.2,
          },
        });
      } else {
        this.data.push({
          message_type: "MESSAGE",
          data: {
            sender: { id: "bot" },
            status: "typing",
            text: "",
            thinking: true,
            id: "/sample-search/eng/9",
          },
        });

        this.data.push({
          message_type: "MESSAGE",
          data: {
            sender: { id: "bot" },
            format: "module_insurance_policy",
            values: {
              id: "/sample-search/eng/9/answer/0",
              text: data.answer,
            },
            id: "/sample-search/eng/9",
            showDefaultInput: false,
            showDefaultUI: true,
            progress: 27.2,
          },
        });

        this.data.push({
          message_type: "MESSAGE",
          data: {
            sender: { id: "bot" },
            id: "/sample-search/eng/10",
            values: "PPO|HMO|EPO|unsure|other",
            continue: false,
            showDefaultUI: true,
            showDefaultInput: true,
            text: "What type of primary insurance is it?",
            subtext: "",
            format: "search",
            progress: 28.3,
          },
        });
      }
    } else if (typeof data.answer === "object") {
      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          status: "typing",
          text: "",
          thinking: true,
          id: "/sample-search/eng/9",
        },
      });

      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          format: "module_insurance_policy",
          values: {
            id: "/sample-search/eng/9/answer/0",
            text: data.answer.name,
          },
          id: "/sample-search/eng/9",
          showDefaultInput: false,
          showDefaultUI: true,
          progress: 27.2,
        },
      });

      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          id: "/sample-search/eng/10",
          values: "PPO|HMO|EPO|unsure|other",
          continue: false,
          showDefaultUI: true,
          showDefaultInput: true,
          text: "What type of primary insurance is it?",
          subtext: "",
          format: "search",
          progress: 30,
        },
      });
    }
  }
}

module.exports = new APIMockSearch();
